<template>
  <div class="flex-row automation-icons gap-xs">
    <a-tooltip placement="top">
      <template #title>Handmatige controle</template>
      <div v-if="needsVerification" class="icon-wrapper">
        <EyeCheckIcon :class="iconClass"/>
      </div>
    </a-tooltip>
    <a-tooltip placement="top">
      <template #title>Verstuurt mail</template>
      <div v-if="sendsEmail || isCampaign" class="icon-wrapper">
        <EmailFastIcon :class="iconClass"/>
      </div>
    </a-tooltip>
    <a-tooltip placement="top">
      <template #title>Genereert signalen</template>
      <div v-if="createsSignal" class="icon-wrapper">
        <BellIcon :class="iconClass"/>
      </div>
    </a-tooltip>
    <a-tooltip placement="top">
      <template #title>Maakt taken aan</template>
      <div v-if="createsTask" class="icon-wrapper">
        <CheckboxOutlineIcon :class="iconClass"/>
      </div>
    </a-tooltip>
    <a-tooltip placement="top">
      <template #title>Voert een data verrijking uit</template>
      <div v-if="isDataEnrichment" class="icon-wrapper">
        <SyncIcon :class="iconClass"/>
      </div>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'AutomationIconComponent',
  props: {
    createsSignal: {
      type: Boolean,
      required: true,
    },
    createsTask: {
      type: Boolean,
      required: true,
    },
    sendsEmail: {
      type: Boolean,
      required: true,
    },
    isDataEnrichment: {
      type: Boolean,
      required: false,
      default: false
    },
    isCampaign: {
      type: Boolean,
      required: false,
      default: false
    },
    needsVerification: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {},

  computed: {
    iconClass () {
      return 'icon-size-md'
    },
  },
  methods: {},
}
</script>


<style lang="scss" scoped>
@import '~@/_default.scss';

.automation-icons {
  .icon-wrapper {
    width: $spacing-xl;
    border-radius: $border-radius-base;
    height: $spacing-xl;
    background-color: $main-content-bg-color;
    color: $text-color;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

</style>
